import useAuth from "./useAuth";
import useProgress from "./useProgress";
import Constants from "../Configuration";

const useDllFiles = () => {
    const {state} = useAuth();
    const {isLoading, error, MessagePanel, BeginLoading} = useProgress();

    const downloadClientFile = async (apiEndpoint: string = Constants.apiEndpoint) => {
        return await BeginLoading(async () => {
            const response = await state.apiService.callApi(Constants.apiEndpoint + 'Config');
            const branch = response.data.branch;
            window.location.href = apiEndpoint + `Download/client/true?stage=${encodeURIComponent(branch)}&fallbackToClient=true`;
        })
    }

    return {
        isLoading,
        error,
        MessagePanel,
        downloadClientFile
    }
}

export default useDllFiles;
